import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './SmsPreview.scss';

const SmsPreview = ({ sms }) => {
  if (!sms) return null;

  const hasError = sms.error;
  const message = sms.fallbackMessage || sms.message || sms.body || (typeof sms === 'string' ? sms : null);

  return (
    <div className='sms-preview-outer'>
      <div className='iphone-shell'>
        <div className='iphone-bezel'>
          <div className='iphone-screen messages-screen'>
            <div className='status-bar dark'>
              <span className='status-time'>9:41</span>
              <div className='dynamic-island' />
              <div className='status-icons'>
                <svg className='status-icon' viewBox='0 0 18 12' fill='currentColor'>
                  <rect x='0' y='7' width='3' height='5' rx='0.5' opacity='0.4' />
                  <rect x='4' y='5' width='3' height='7' rx='0.5' opacity='0.6' />
                  <rect x='8' y='3' width='3' height='9' rx='0.5' opacity='0.8' />
                  <rect x='12' y='0' width='3' height='12' rx='0.5' />
                </svg>
                <svg className='status-icon' viewBox='0 0 16 12' fill='currentColor'>
                  <path d='M8 3.6c1.8 0 3.4.7 4.6 1.9l1.1-1.1C12.1 2.8 10.1 2 8 2s-4.1.8-5.7 2.4l1.1 1.1C4.6 4.3 6.2 3.6 8 3.6z' />
                  <path d='M8 6.8c1 0 2 .4 2.8 1.1l1.1-1.1C10.7 5.6 9.4 5.2 8 5.2s-2.7.4-3.9 1.6l1.1 1.1C6 6.9 7 6.8 8 6.8z' />
                  <circle cx='8' cy='10' r='1.5' />
                </svg>
                <div className='battery-icon'>
                  <div className='battery-body'>
                    <div className='battery-fill' />
                  </div>
                  <div className='battery-cap' />
                </div>
              </div>
            </div>

            <div className='messages-nav'>
              <div className='nav-back'>
                <svg viewBox='0 0 12 20' fill='currentColor' className='back-chevron'>
                  <path d='M10.6 1.4L9.2 0 0 9.2l.7.8L9.2 18.5l1.4-1.4L2.8 9.2z' />
                </svg>
                <span>Messages</span>
              </div>
              <div className='nav-contact'>
                <div className='contact-avatar'>S</div>
                <div className='contact-info'>
                  <div className='contact-name'>ShopMy</div>
                  <div className='contact-detail'>SMS</div>
                </div>
              </div>
              <div className='nav-spacer' />
            </div>

            <div className='messages-body'>
              <div className='messages-timestamp'>Today 9:41 AM</div>
              {hasError ? (
                <div className={cn('sms-bubble', 'error')}>Error: {sms.error}</div>
              ) : message ? (
                <div className='sms-bubble incoming'>{message}</div>
              ) : (
                <div className='sms-bubble incoming empty'>No SMS content available</div>
              )}
            </div>

            <div className='messages-input-bar'>
              <div className='input-actions-left'>
                <svg viewBox='0 0 24 24' fill='currentColor' className='input-icon'>
                  <circle cx='12' cy='12' r='10' fill='none' stroke='currentColor' strokeWidth='1.5' />
                  <line x1='12' y1='8' x2='12' y2='16' stroke='currentColor' strokeWidth='1.5' />
                  <line x1='8' y1='12' x2='16' y2='12' stroke='currentColor' strokeWidth='1.5' />
                </svg>
              </div>
              <div className='input-field'>
                <span className='input-placeholder'>iMessage</span>
              </div>
              <div className='input-actions-right'>
                <svg viewBox='0 0 24 24' fill='currentColor' className='send-icon'>
                  <circle cx='12' cy='12' r='11' fill='#007AFF' />
                  <path d='M12 6l-1 1 4 4H7v1.5h8l-4 4 1 1 6-6z' fill='white' />
                </svg>
              </div>
            </div>

            <div className='home-indicator-area light'>
              <div className='home-indicator' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SmsPreview.propTypes = {
  sms: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

export default SmsPreview;
